import * as React from 'react';
import styled from 'styled-components';
import { hexToRgb } from '@latitude/core/helpers';
import { COLOR } from '@latitude/core/utils/constants';
import { Link } from '@latitude/link';
import { formatTelNo } from './Tel.helpers';
var StyledComponent = /*#__PURE__*/styled(Link).withConfig({
  displayName: "Tel__StyledComponent",
  componentId: "sc-1y94rr7-0"
})(["cursor:pointer;white-space:nowrap;", ";", ";"], function (_ref) {
  var noStyle = _ref.noStyle;
  return noStyle && "border: none !important;\n     color: inherit !important;\n     text-decoration: none !important;\n  ";
}, function (_ref2) {
  var cssColor = _ref2.cssColor,
      noStyle = _ref2.noStyle;
  return !noStyle && cssColor && "color: " + cssColor + " !important;\n     border-bottom: solid 1px rgba(" + hexToRgb(cssColor) + ", 0.5) !important;\n  ";
});

var Tel = function Tel(_ref3) {
  var id = _ref3.id,
      className = _ref3.className,
      color = _ref3.color,
      no = _ref3.no,
      noStyle = _ref3.noStyle;
  var props = {
    id: id,
    className: className,
    cssColor: color,
    no: no,
    noStyle: noStyle
  };
  return /*#__PURE__*/React.createElement(StyledComponent, Object.assign({}, props, {
    href: "tel:" + formatTelNo(props.no)
  }), props.no);
};

export default Tel;